import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";

import CreateIcon from "@material-ui/icons/Create";
import { IManagementStore } from "Stores/Management/types";
import { Values } from "Tools/Values";
import { Dialog, DialogContent } from "@material-ui/core";
import { IAuthApplication } from "@src/Interfaces/Entity/OAuthApplication";
import AuthApplicationForm from "../AuthApplicationForm/AuthApplicationForm";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  management?: IManagementStore;
  oAuthApplication: IAuthApplication;
}

@inject("management")
@observer
export default class EditAuthApplication extends React.Component<IProps> {
  @observable editOpened: boolean = false;

  handleOpenEdit = () => {
    this.editOpened = true;
  };
  handleCloseEdit = () => {
    this.editOpened = false;
  };

  handleUpdate = async (values: IAuthApplication) => {
    await this.props.management.saveOAuthApplication(values);
    this.editOpened = false;
  };

  render() {
    return (
      <React.Fragment>
        <RoundButton
          icon={<CreateIcon/>}
          tooltipTitle={Values.getLocalizationValue("edit")}
          onClick={() => this.handleOpenEdit()}
        />

        <Dialog
          open={this.editOpened}
          onClose={this.handleCloseEdit}
        >
          <DialogContent>
            <AuthApplicationForm
              title={Values.getLocalizationValue("add")}
              initialValues={this.props.oAuthApplication}
              onSubmit={this.handleUpdate}
              onClose={this.handleCloseEdit}
            />
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
